import { evalCondition } from 'mailup-react-helpers'
import {
  FormElement,
  HelpIcon,
  InputTextIcon,
  TooltipUtils
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'

const LockedSenderEmail = ({ value }) => {
  const intl = useIntl()
  const isWL = evalCondition('co:WHITELABEL')

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [])

  const Help = () => (
    <HelpIcon
      text={intl.formatMessage({ id: 'Load.PecPlus.AltImgMailMittPec' })}
    />
  )

  return (
    <FormElement
      label={intl.formatMessage({ id: 'Load.Common.SenderEmailLabel' })}
      required
      LabelRightComponent={Help}
    >
      <InputTextIcon
        tooltip={intl.formatMessage({
          id: isWL
            ? 'Load.PecPlus.senderPecTooltipWL'
            : 'Load.PecPlus.senderPecTooltip'
        })}
        value={value}
        disabled
      />
    </FormElement>
  )
}

LockedSenderEmail.propTypes = {
  value: PropTypes.string
}

export default LockedSenderEmail
